import { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';

interface ModalProps {
  title: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  description?: ReactNode;
  isDialogOpen?: boolean;
  setIsDialogOpen?: (isOpen: boolean) => void;
  contentClassName?: string;
  headerClassName?: string;
  descriptionClassName?: string;
  footerClassName?: string;
  hideCloseButton?: boolean; // If true, hides the X close button
  preventClose?: boolean; // If true, prevents closing via overlay click or ESC key
}

export const Modal = ({
  title,
  children,
  isDialogOpen,
  setIsDialogOpen,
  footer,
  description,
  contentClassName = '',
  headerClassName = '',
  descriptionClassName = '',
  footerClassName = '',
  hideCloseButton = false,
  preventClose = false,
}: ModalProps) => {
  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogContent
        className={`${contentClassName} max-h-[90vh] px-2!important flex flex-col`}
        hideCloseButton={hideCloseButton}
        preventClose={preventClose}
      >
        <DialogHeader className={headerClassName}>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {description && (
          <DialogDescription className={descriptionClassName}>
            {description}
          </DialogDescription>
        )}
        <div className='overflow-y-auto flex-1 p-1 -m-1'>{children}</div>
        {footer && (
          <DialogFooter className={footerClassName}>{footer}</DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
